import React, { useEffect } from 'react';
import { observer } from "mobx-react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Button, Form, Input, message } from "antd";
import { useStore } from "../../store";
import { debounce } from "lodash";
import { editPwd } from "../../http/manager";
interface EditPwd {
  onSuccess: ()=> void;
}

const ChangePassword: React.FC<EditPwd> = ({onSuccess})=> {
    const { editPwdStore } = useStore();
    const [ form ] = Form.useForm();
    const navigateTo = useNavigate();

    useEffect(() => {
    }, [form]);

    const onFormFinish = (changeValue: any) => {
        const {useraccount, password, newpwd} = changeValue;
        if (useraccount) {
            editPwdStore.setUseraccount(useraccount);
        }
        if (password) {
            editPwdStore.setPassword(password);
        }
        if (newpwd) {
            editPwdStore.setNewpwd(newpwd);
        }
    }
    const toSave = async ()=> {
      try {
        const values = await form.validateFields();
        if(values.useraccount && values.password && values.newpwd ) {
          editDebounce();
        }
        console.log('Success:', values);
      } catch (errorInfo) {
        console.log('Failed:', errorInfo);
      }
    }
    const save = ()=> {
        const formData = new FormData();
        formData.append("useraccount", editPwdStore.useraccount);
        formData.append("password", editPwdStore.password);
        formData.append("newpwd", editPwdStore.newpwd);
        editPwd(formData).then((res: any)=> {
            if (res && res.data) {
                message.success("修改成功");
                editPwdStore.setUseraccount('');
                editPwdStore.setPassword('');
                editPwdStore.setNewpwd('');
                onSuccess();
            } else {
                message.error("修改失败");
            }
        })
    }
    const editDebounce = debounce(save, 500)
    return (
            <Wrapper>
              <Form form={form} size={"middle"} style={{width: '100%', marginTop: '15px'}}
                  labelCol={{ span: 5 }}
                  wrapperCol={{ span: 17 }}
                  onValuesChange={ onFormFinish }
                  initialValues={{
                      useraccount: '', 
                      password: '', 
                      newpwd: '',
                  }}>
                  <Form.Item
                      label="账号"
                      rules={[{ required: true, message: '请输入账号' }]}
                      name="useraccount"
                      >
                      <Input />
                  </Form.Item>
                  <Form.Item
                      label="原密码"
                      rules={[{ required: true, message: '请输入原密码' }]}
                      name="password"
                      >
                      <Input.Password />
                  </Form.Item>
                  <Form.Item
                      label="新密码"
                      rules={[{ required: true, message: '请输入新密码' }]}
                      name="newpwd"
                      >
                      <Input.Password />
                  </Form.Item>
            </Form>
            <Button onClick={toSave} type={"primary"} style={{width: "100px"}}>提交</Button>
          </Wrapper>
    )
}

export default observer(ChangePassword);

const Wrapper = styled.div`
& {
  display: flex;
  flex-direction: column;
  align-items: center;
}
`;